var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffed7d",
    d: "M12 23.64A12 12 0 0 1 .003 11.82V12a12 12 0 1 0 24 0v-.18A12 12 0 0 1 12 23.64",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffed7d",
    d: "M12 .451a12 12 0 0 1 11.997 11.775V12a12 12 0 0 0-24 0v.226A12 12 0 0 1 12 .45"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M12 23.945c6.596 0 11.944-5.348 11.944-11.944S18.596.057 12 .057.056 5.404.056 12c0 6.596 5.347 11.944 11.944 11.944",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M12 .045A11.95 11.95 0 0 0 .056 11.67c1.32.783 3.398.157 4.756-.523 1.169-.54 2.605-.36 3.864-.27 3.144.27 6.201 1.613 9.343.81.629-.18 1.527-.993 2.156-.45a3.51 3.51 0 0 0 3.769.44A11.95 11.95 0 0 0 12 .046",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M12 21.86c5.446 0 9.86-4.415 9.86-9.86 0-5.447-4.414-9.861-9.86-9.861s-9.86 4.414-9.86 9.86 4.414 9.86 9.86 9.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8e20",
    d: "M12 21.383a9.382 9.382 0 1 0 0-18.764 9.382 9.382 0 0 0 0 18.764"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M12 20.999a8.999 8.999 0 1 0 0-17.997 8.999 8.999 0 0 0 0 17.997"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffed7d",
    d: "M12 20.328c-4.89 0-8.868-3.709-8.996-8.568V12A8.998 8.998 0 1 0 21 12v-.24c-.133 4.86-4.11 8.568-9.001 8.568",
    opacity: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M12.296 23.037c3.499 0 6.335-2.765 6.335-6.177s-2.837-6.176-6.335-6.176c-3.5 0-6.336 2.765-6.336 6.176s2.836 6.177 6.336 6.177",
    opacity: 0.63
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M11.875 14.662c3.499 0 6.335-2.765 6.335-6.177S15.374 2.31 11.875 2.31 5.539 5.074 5.539 8.485s2.837 6.177 6.336 6.177",
    opacity: 0.63
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M18.77 10.868c-.084 0-.184-.017-.268-.017-1.925 0-3.85 0-5.775.017a.43.43 0 0 0-.318.22c-.753 1.305-.753 1.305-.134 2.695.017.017.017.068.034.068.117.085.25.237.385.237.686.017 1.372.017 2.075.017h.754c-.067.136-.151.254-.235.373-.937 1-2.092 1.576-3.465 1.509-1.456-.068-2.51-.882-3.18-2.102-.787-1.424-2.16-1.814-3.516-2.305-.267 1.847.67 4.678 3.18 6.254 2.545 1.627 5.81 1.407 8.136-.508 2.11-1.78 2.83-4.628 2.327-6.458M10.2 8.85c.535-.22 1.104-.407 1.673-.44 1.54-.103 2.746.575 3.65 1.88l2.812-1.084a6.71 6.71 0 0 0-6.612-4.119c-2.344.119-4.185 1.186-5.558 3.17.603.237 1.155.39 1.657.644.82.406 1.574.288 2.377-.051m-1.691 1.17c.083.033.217-.085.318-.136l-.034-.136c-.887-.339-1.774-.695-2.661-1.034-.1-.034-.251.051-.369.085l.017.17c.904.355 1.825.711 2.729 1.05m-3.231 1.135c.887.356 1.791.712 2.695 1.05l.1-.084c-.066-.118-.1-.288-.2-.322-.87-.356-1.775-.695-2.662-1.034l-.134.085c.084.118.117.271.201.305m.452-1.407c.77.288 1.557.593 2.327.899.234.101.351.05.351-.255L5.63 9.325c-.201.238-.151.34.1.424m-.285.678q1.305.534 2.612 1.017l.1-.085c-.067-.101-.1-.288-.2-.322-.854-.339-1.708-.66-2.545-1l-.117.051c.05.119.067.305.15.34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M18.77 10.868c-.084 0-.184-.017-.268-.017-1.925 0-3.85 0-5.775.017a.43.43 0 0 0-.318.22c-.753 1.305-.753 1.305-.134 2.695.017.017.017.068.034.068.117.085.25.237.385.237.686.017 1.372.017 2.075.017h.754c-.067.136-.151.254-.235.373-.937 1-2.092 1.576-3.465 1.509-1.456-.068-2.51-.882-3.18-2.102-.787-1.424-2.16-1.814-3.516-2.305-.267 1.847.67 4.678 3.18 6.254 2.545 1.627 5.81 1.407 8.136-.508 2.11-1.78 2.83-4.628 2.327-6.458M10.2 8.85c.535-.22 1.104-.407 1.673-.44 1.54-.103 2.746.575 3.65 1.88l2.812-1.084a6.71 6.71 0 0 0-6.612-4.119c-2.344.119-4.185 1.186-5.558 3.17.603.237 1.155.39 1.657.644.82.406 1.574.288 2.377-.051m-1.691 1.17c.083.033.217-.085.318-.136l-.034-.136c-.887-.339-1.774-.695-2.661-1.034-.1-.034-.251.051-.369.085l.017.17c.904.355 1.825.711 2.729 1.05m-3.231 1.135c.887.356 1.791.712 2.695 1.05l.1-.084c-.066-.118-.1-.288-.2-.322-.87-.356-1.775-.695-2.662-1.034l-.134.085c.084.118.117.271.201.305m.452-1.407c.77.288 1.557.593 2.327.899.234.101.351.05.351-.255L5.63 9.325c-.201.238-.151.34.1.424m-.285.678q1.305.534 2.612 1.017l.1-.085c-.067-.101-.1-.288-.2-.322-.854-.339-1.708-.66-2.545-1l-.117.051c.05.119.067.305.15.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M18.77 10.868c-.084 0-.184-.017-.268-.017-1.925 0-3.85 0-5.775.017a.43.43 0 0 0-.318.22c-.753 1.305-.753 1.305-.134 2.695.017.017.017.068.034.068.117.085.25.237.385.237.686.017 1.372.017 2.075.017h.754c-.067.136-.151.254-.235.373-.937 1-2.092 1.576-3.465 1.509-1.456-.068-2.51-.882-3.18-2.102-.787-1.424-2.16-1.814-3.516-2.305-.267 1.847.67 4.678 3.18 6.254 2.545 1.627 5.81 1.407 8.136-.508 2.11-1.78 2.83-4.628 2.327-6.458M10.2 8.85c.535-.22 1.104-.407 1.673-.44 1.54-.103 2.746.575 3.65 1.88l2.812-1.084a6.71 6.71 0 0 0-6.612-4.119c-2.344.119-4.185 1.186-5.558 3.17.603.237 1.155.39 1.657.644.82.406 1.574.288 2.377-.051m-1.691 1.17c.083.033.217-.085.318-.136l-.034-.136c-.887-.339-1.774-.695-2.661-1.034-.1-.034-.251.051-.369.085l.017.17c.904.355 1.825.711 2.729 1.05m-3.231 1.135c.887.356 1.791.712 2.695 1.05l.1-.084c-.066-.118-.1-.288-.2-.322-.87-.356-1.775-.695-2.662-1.034l-.134.085c.084.118.117.271.201.305m.452-1.407c.77.288 1.557.593 2.327.899.234.101.351.05.351-.255L5.63 9.325c-.201.238-.151.34.1.424m-.285.678q1.305.534 2.612 1.017l.1-.085c-.067-.101-.1-.288-.2-.322-.854-.339-1.708-.66-2.545-1l-.117.051c.05.119.067.305.15.34"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffbe0",
    fillOpacity: 0.29,
    d: "M5.111 11.707c.06.106.096.219.167.247.883.355 1.782.709 2.682 1.046.257.243.488.533.683.885.67 1.22 1.724 2.034 3.18 2.101 1.163.058 2.17-.349 3.02-1.082h.68c-.067.135-.151.254-.235.373-.937 1-2.093 1.576-3.465 1.508-1.456-.068-2.51-.881-3.18-2.101-.787-1.424-2.16-1.814-3.515-2.306q-.017.12-.028.246-.037-.485.011-.917M18.502 10.85c.084 0 .184.018.268.018.133.484.18 1.04.138 1.628a4.4 4.4 0 0 0-.138-.83c-.084 0-.184-.016-.268-.016-1.925 0-3.85 0-5.775.016a.43.43 0 0 0-.318.22c-.255.442-.421.734-.51.981-.18-.581-.028-.848.51-1.779a.43.43 0 0 1 .318-.22c1.925-.018 3.85-.017 5.775-.017M5.825 11c.687.262 1.377.526 2.047.8l.022.011c-.693-.274-1.386-.539-2.069-.81M5.166 11.593l-.044.027.006-.04zM5.977 10.642c.64.241 1.289.492 1.927.745a83 83 0 0 1-1.927-.745M5.403 10.84l-.108.047c.047.111.065.28.136.33l-.153-.061c-.084-.034-.117-.187-.2-.305l.133-.085zM8.091 10.66q-.016-.005-.034-.012l-.034-.014zM5.63 10.124c-.158.186-.16.287-.033.364l-.152-.061c-.083-.034-.1-.22-.15-.34l.117-.05q.109.044.217.087M8.408 10.393v.004l-1.2-.465zM6.132 8.715l.218.084q-.094.126-.185.257c.603.237 1.155.39 1.658.644.304.151.6.23.891.251-.074.047-.15.092-.205.07-.904-.34-1.825-.696-2.729-1.052l-.016-.17c.117-.033.267-.118.368-.084M6.11 9.51c-.1-.017-.237.057-.346.089l.016.169-.05-.02c-.251-.084-.301-.186-.1-.423zM11.723 5.088a6.71 6.71 0 0 1 6.612 4.118l-.325.126a6.72 6.72 0 0 0-6.288-3.445c-2.084.105-3.771.962-5.085 2.546a15 15 0 0 1-.472-.176c1.373-1.983 3.214-3.05 5.558-3.169"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd92f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ffdf3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ffe64f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffe955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9d23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 12,
    x2: 12,
    y1: 22.002,
    y2: 4.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7b6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 12,
    x2: 12,
    y1: 21.86,
    y2: -2.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffcc26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ffaf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 7.769,
    x2: 18.113,
    y1: 3.193,
    y2: 24.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#da6119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c94b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b22e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a92308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 7.769,
    x2: 18.107,
    y1: 3.193,
    y2: 24.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#da6119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c94b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b22e0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a92308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 11.831,
    x2: 12.125,
    y1: 3.532,
    y2: 21.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffec72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbf3d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.88 -1.65)scale(9.55659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7b6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.463 2.967)scale(20.9612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fdd41c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e56316"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(12.296 16.86)scale(6.25612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99230d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c23416",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.875 8.485)scale(6.25612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d72d13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe5d22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 15.846,
    height: 16.346,
    x: 4.077,
    y: 5.076,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.5625 0 0 0 0 0.15 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2290_4108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2290_4108",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.62368b24b7c78706d90f2750ce9042f5.svg";
export { ForwardRef as ReactComponent };